export enum HeaderPermission {
    change_company = 'core: change company',
}
